export default __webpack_public_path__ + "static/media/wiserr.d03c2a61.svg";